"use strict";
/**
 * Source Material:
 * https://github.com/disruptops/trinity-api/blob/develop/api/common/permissions.py
 *
 * Pick and choose pieces as-needed for porting.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var Permissions;
(function (Permissions) {
    Permissions["VIEW_ACCOUNTS"] = "2699042a-a81d-43bc-9a09-0113c9e1488e";
    Permissions["MODIFY_ACCOUNTS"] = "1667bb9f-056e-481b-900c-dffce38d9b4b";
    Permissions["VIEW_ACTION_RESULTS"] = "dd548360-493a-451e-adb7-b0bd22a72b75";
    Permissions["MODIFY_ACTION_RESULTS"] = "d24c82ec-63d3-4055-bb19-b6eb9ca4eb07";
    Permissions["VIEW_ASSESSMENTS"] = "7dfc3990-1621-45f1-a766-f9d63f4bd306";
    Permissions["MODIFY_ASSESSMENTS"] = "63267de1-5aeb-4029-8e40-fde2c9a09e9b";
    Permissions["VIEW_CLIENTS"] = "e0943957-5f92-44e3-a52d-8f1b0dd3fdd8";
    Permissions["MODIFY_CLIENTS"] = "8d299ab4-1d37-43ea-afbe-1ff58e45e062";
    Permissions["VIEW_CLIENT_API_KEYS"] = "55a27cfd-bd61-4a2b-8a9e-abffe39f470a";
    Permissions["MODIFY_CLIENT_API_KEYS"] = "0273025e-3e57-4881-8e68-e95f0ce7c19a";
    Permissions["VIEW_COMPLIANCE"] = "01dbb4ad-49b6-4180-a5d0-58a5bdecd649";
    Permissions["VIEW_CONFIGURED_OPS"] = "79c5b365-1c47-4df1-86a9-b3579a403c0e";
    Permissions["MODIFY_CONFIGURED_OPS"] = "e80a6757-8761-4433-967b-6fcce4f75468";
    Permissions["VIEW_EVENTS"] = "504c24e7-4056-48dc-91ea-150fddc7ac01";
    Permissions["VIEW_GUARDRAILS"] = "b9d44e2a-828a-43ea-9be3-36fd078a8010";
    Permissions["MODIFY_GUARDRAILS"] = "4c9ca36f-d5bf-4dfa-a967-dd00aea6b1f6";
    Permissions["VIEW_ISSUES"] = "3656ce5a-5e1c-49dc-9253-49e45bac263d";
    Permissions["MODIFY_ISSUES"] = "ebf55db8-c560-427f-9320-0c62c612bf88";
    Permissions["VIEW_NOTIFICATIONS"] = "8f538ec2-e8b1-4a73-b599-6b460d51e437";
    Permissions["MODIFY_NOTIFICATIONS"] = "07aacacf-e2bb-4d1f-b15c-c04f926df747";
    Permissions["VIEW_OPS"] = "bd470e6d-7efe-4174-933c-e9813b0bad78";
    Permissions["INSTALL_OPS"] = "95e7b399-a0d2-4026-989e-f47cd5ccaf81";
    Permissions["VIEW_PERMISSIONS"] = "8c97858f-685b-4fdc-872b-343a0b056a03";
    Permissions["VIEW_POLICIES"] = "3a1bc7df-77d6-45ac-a1cc-9d2e1c2bdeb7";
    Permissions["MODIFY_POLICIES"] = "b81230d3-91ce-4c5f-a833-970c4766f4ea";
    Permissions["VIEW_PROJECTS"] = "d8334fda-1318-4dbc-8164-066678d73231";
    Permissions["MODIFY_PROJECTS"] = "07671e41-7541-4aa7-a900-6a62add5a4c4";
    Permissions["VIEW_ROLES"] = "8d67526b-e086-401b-b31c-8c5ca43959f4";
    Permissions["MODIFY_ROLES"] = "b37979c3-6b9b-4bc1-b744-2ee1c125cb1f";
    Permissions["VIEW_RUNS"] = "d28a62ac-285c-40d2-b84e-56e23f3aade3";
    Permissions["VIEW_SETTINGS"] = "74b9484c-6fe5-4903-9d1a-2ca0405bbfe4";
    Permissions["MODIFY_SETTINGS"] = "cf9f0b41-df1e-49a4-9602-f50118dd5ee1";
    Permissions["VIEW_REPORTS"] = "6378c110-691f-42ec-85df-a7e22975de1f";
    Permissions["MODIFY_REPORTS"] = "f7530405-0cf0-4637-b659-73c96a0e0b4a";
    Permissions["VIEW_USERS"] = "ad227a99-b4a4-496e-83a3-59e9461309d4";
    Permissions["MODIFY_USERS"] = "891511e3-3beb-4729-8ecd-a5153de2d014";
    Permissions["VIEW_USER_GROUPS"] = "67767d11-e66a-42bc-926d-ac7b6b19df59";
    Permissions["MODIFY_USER_GROUPS"] = "6e6ea8c2-44aa-4b13-9e78-91ace4095786";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
// A mapping for internal seeding, errors, and other lookups.
exports.PERMISSION_LIST = [
    {
        id: Permissions.VIEW_ACCOUNTS,
        key: 'VIEW_ACCOUNTS',
        name: 'View Accounts',
        description: ''
    },
    {
        id: Permissions.MODIFY_ACCOUNTS,
        key: 'MODIFY_ACCOUNTS',
        name: 'Modify Accounts',
        description: ''
    },
    {
        id: Permissions.VIEW_ACTION_RESULTS,
        key: 'VIEW_ACTION_RESULTS',
        name: 'View Action Results',
        description: ''
    },
    {
        id: Permissions.MODIFY_ACTION_RESULTS,
        key: 'MODIFY_ACTION_RESULTS',
        name: 'Modify Action Results',
        description: ''
    },
    {
        id: Permissions.VIEW_ASSESSMENTS,
        key: 'VIEW_ASSESSMENTS',
        name: 'View Assessments',
        description: ''
    },
    {
        id: Permissions.MODIFY_ASSESSMENTS,
        key: 'MODIFY_ASSESSMENTS',
        name: 'Modify Assessments',
        description: ''
    },
    {
        id: Permissions.VIEW_CLIENTS,
        key: 'VIEW_CLIENTS',
        name: 'View Clients',
        description: ''
    },
    {
        id: Permissions.MODIFY_CLIENTS,
        key: 'MODIFY_CLIENTS',
        name: 'Modify Clients',
        description: ''
    },
    {
        id: Permissions.VIEW_CLIENT_API_KEYS,
        key: 'VIEW_CLIENT_API_KEYS',
        name: 'View Client API Keys',
        description: ''
    },
    {
        id: Permissions.MODIFY_CLIENT_API_KEYS,
        key: 'MODIFY_CLIENT_API_KEYS',
        name: 'Modify Client API Keys',
        description: ''
    },
    {
        id: Permissions.VIEW_COMPLIANCE,
        key: 'VIEW_COMPLIANCE',
        name: 'View Compliance',
        description: ''
    },
    {
        id: Permissions.VIEW_CONFIGURED_OPS,
        key: 'VIEW_CONFIGURED_OPS',
        name: 'View Configured Ops',
        description: ''
    },
    {
        id: Permissions.MODIFY_CONFIGURED_OPS,
        key: 'MODIFY_CONFIGURED_OPS',
        name: 'Modify Configured Ops',
        description: ''
    },
    {
        id: Permissions.VIEW_EVENTS,
        key: 'VIEW_EVENTS',
        name: 'View Events',
        description: ''
    },
    {
        id: Permissions.VIEW_GUARDRAILS,
        key: 'VIEW_GUARDRAILS',
        name: 'View Guardrails',
        description: ''
    },
    {
        id: Permissions.MODIFY_GUARDRAILS,
        key: 'MODIFY_GUARDRAILS',
        name: 'Modify Guardrails',
        description: ''
    },
    {
        id: Permissions.VIEW_ISSUES,
        key: 'VIEW_ISSUES',
        name: 'View Issues',
        description: ''
    },
    {
        id: Permissions.MODIFY_ISSUES,
        key: 'MODIFY_ISSUES',
        name: 'Modify Issues',
        description: ''
    },
    {
        id: Permissions.VIEW_NOTIFICATIONS,
        key: 'VIEW_NOTIFICATIONS',
        name: 'View Notifications',
        description: ''
    },
    {
        id: Permissions.MODIFY_NOTIFICATIONS,
        key: 'MODIFY_NOTIFICATIONS',
        name: 'Modify Notifications',
        description: ''
    },
    {
        id: Permissions.VIEW_OPS,
        key: 'VIEW_OPS',
        name: 'View Ops',
        description: ''
    },
    {
        id: Permissions.INSTALL_OPS,
        key: 'INSTALL_OPS',
        name: 'Install Ops',
        description: ''
    },
    {
        id: Permissions.VIEW_PERMISSIONS,
        key: 'VIEW_PERMISSIONS',
        name: 'View Permissions',
        description: ''
    },
    {
        id: Permissions.VIEW_POLICIES,
        key: 'VIEW_POLICIES',
        name: 'View Policies',
        description: ''
    },
    {
        id: Permissions.MODIFY_POLICIES,
        key: 'MODIFY_POLICIES',
        name: 'Modify Policies',
        description: ''
    },
    {
        id: Permissions.VIEW_PROJECTS,
        key: 'VIEW_PROJECTS',
        name: 'View Projects',
        description: ''
    },
    {
        id: Permissions.MODIFY_PROJECTS,
        key: 'MODIFY_PROJECTS',
        name: 'Modify Projects',
        description: ''
    },
    {
        id: Permissions.VIEW_REPORTS,
        key: 'VIEW_REPORTS',
        name: 'View Reports',
        description: ''
    },
    {
        id: Permissions.MODIFY_REPORTS,
        key: 'MODIFY_REPORTS',
        name: 'Modify Reports',
        description: ''
    },
    {
        id: Permissions.VIEW_ROLES,
        key: 'VIEW_ROLES',
        name: 'View Roles',
        description: ''
    },
    {
        id: Permissions.MODIFY_ROLES,
        key: 'MODIFY_ROLES',
        name: 'Modify Roles',
        description: ''
    },
    {
        id: Permissions.VIEW_RUNS,
        key: 'VIEW_RUNS',
        name: 'View Runs',
        description: ''
    },
    {
        id: Permissions.VIEW_SETTINGS,
        key: 'VIEW_SETTINGS',
        name: 'View Settings',
        description: ''
    },
    {
        id: Permissions.MODIFY_SETTINGS,
        key: 'MODIFY_SETTINGS',
        name: 'Modify Settings',
        description: ''
    },
    {
        id: Permissions.VIEW_USERS,
        key: 'VIEW_USERS',
        name: 'View Users',
        description: ''
    },
    {
        id: Permissions.MODIFY_USERS,
        key: 'MODIFY_USERS',
        name: 'Modify Users',
        description: ''
    },
    {
        id: Permissions.VIEW_USER_GROUPS,
        key: 'VIEW_USER_GROUPS',
        name: 'View User Groups',
        description: ''
    },
    {
        id: Permissions.MODIFY_USER_GROUPS,
        key: 'MODIFY_USER_GROUPS',
        name: 'Modify User Groups',
        description: ''
    }
];
function getPermission(perm) {
    return exports.PERMISSION_LIST.find(permission => permission.id === perm);
}
exports.getPermission = getPermission;
//# sourceMappingURL=permissions.js.map